/** Seeded table ids used for "practice vs bots" after tutorials (cheapest/free tables). */
export const SEED_PRACTICE: Record<string, string> = {
  CALL_BREAK: '00000000-0000-4000-8000-000000000106',
  SPADES: '00000000-0000-4000-8000-000000000506',
  TARNEEB: '00000000-0000-4000-8000-000000000606',
  HEARTS: '00000000-0000-4000-8000-000000000706',
  FIVE_HUNDRED: '00000000-0000-4000-8000-000000000806',
  JUDGEMENT: '00000000-0000-4000-8000-000000000906',
  RUMMY: '00000000-0000-4000-8000-000000001006',
  EUCHRE: '00000000-0000-4000-8000-000000001106',
  GIN_RUMMY: '00000000-0000-4000-8000-000000001206',
  TWENTY_NINE: '00000000-0000-4000-8000-000000001306',
  CRAZY_EIGHTS: '00000000-0000-4000-8000-000000001406',
  CRIBBAGE: '00000000-0000-4000-8000-000000001506',
  BLACKJACK: '00000000-0000-4000-8000-000000001606',
  BHABHI: '00000000-0000-4000-8000-000000001706',
  PINOCHLE: '00000000-0000-4000-8000-000000001806',
  ANDAR_BAHAR: '00000000-0000-4000-8000-000000001906',
  BRIDGE: '00000000-0000-4000-8000-000000002006',
  SEVENS: '00000000-0000-4000-8000-000000002106',
  SCOPA: '00000000-0000-4000-8000-000000002206',
  BACCARAT: '00000000-0000-4000-8000-000000002306',
  BLUFF: '00000000-0000-4000-8000-000000002406',
  DRAGON_TIGER: '00000000-0000-4000-8000-000000002506',
  FLUSH: '00000000-0000-4000-8000-000000002606',
  COURT_PIECE: '00000000-0000-4000-8000-000000002706',
  DEHLA_PAKAD: '00000000-0000-4000-8000-000000002806',
  WHIST: '00000000-0000-4000-8000-000000002906',
  SEEP: '00000000-0000-4000-8000-000000003006',
  BELOTE: '00000000-0000-4000-8000-000000003106',
  DURAK: '00000000-0000-4000-8000-000000003206',
  PRESIDENT: '00000000-0000-4000-8000-000000003306',
  BRISCOLA: '00000000-0000-4000-8000-000000003406',
  CASINO_WAR: '00000000-0000-4000-8000-000000003506',
  THREE_CARD_POKER: '00000000-0000-4000-8000-000000003606',
  GO_FISH: '00000000-0000-4000-8000-000000003706',
  TRESSETTE: '00000000-0000-4000-8000-000000003806',
  RED_DOG: '00000000-0000-4000-8000-000000003906',
  CANASTA: '00000000-0000-4000-8000-000000004006',
  SKAT: '00000000-0000-4000-8000-000000004106',
  PAI_GOW: '00000000-0000-4000-8000-000000004206',
  BIG_TWO: '00000000-0000-4000-8000-000000004306',
  WAR: '00000000-0000-4000-8000-000000004406',
  RUMMY_500: '00000000-0000-4000-8000-000000004506',
  BRAG: '00000000-0000-4000-8000-000000004606',
  PITCH: '00000000-0000-4000-8000-000000004706',
  HAZARI: '00000000-0000-4000-8000-000000004806',
  TEEN_PATTI: '00000000-0000-4000-8000-000000000205',
  POKER: '00000000-0000-4000-8000-000000000305',
  MARRIAGE: '00000000-0000-4000-8000-000000000404',
};
